import { orchestrator } from 'satcheljs';
import setIsRemovingDomain from '../mutators/setIsRemovingDomain';
import { deleteRequest } from '../services/deleteRequest';
import { getDomainState } from '../actions/getDomainState';
import { removeDomain } from '../actions/removeDomain';
import { traceRemoveDomainButtonClick } from '../utils/domainOptionTracer';

const deleteDomainUrl: string = 'ows/api/v1/PremiumDomain/';

export default orchestrator(removeDomain, async function removeDomain() {
    traceRemoveDomainButtonClick();
    setIsRemovingDomain(true);
    await deleteRequest(deleteDomainUrl);
    setIsRemovingDomain(false);
    getDomainState();
});
